var modal = document.getElementById("modal1");
var btn = document.getElementById("btn1");
var span = document.getElementsByClassName("close1")[0];


document.body.appendChild(modal);



btn.onclick = function() {
  modal.style.display = "block";
}
span.onclick = function() {
  modal.style.display = "none";
}
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

function zodiac_dizhi(p){
  var input = document.getElementById('birthday1').value;
  var date = new Date(input.replace(/-/g, '\/'));
  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();
  document.getElementById("zodiactxt1").value = get_zodiac(year, month, day);
}

function get_zodiac(year, month, day) {
  
  if (year < 1924 || year > 2044) {
    return 'Please enter a year between 1924 and 2044.';
  }
  
  var zodiac_list = ['Capricorn', 'Aquarius', 'Pisces', 'Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 'Libra', 'Scorpio', 'Sagittarius', 'Capricorn'];
  var last = [19, 18, 20, 20, 21, 21, 22, 22, 21, 22, 21, 20, 19];
  zodiac = (day > last[month - 1]) ? zodiac_list[month] : zodiac_list[month - 1];
  
  var start = 1924;
  i = (start - year) % 12;
  if (i < 0)
  {
    i += 12;
  }
  
  var dizhi_list = ['Rat','Pig','Dog','Rooster','Monkey','Sheep','Horse','Snake','Dragon','Rabbit','Tiger','Ox','Rat'];
  var CNY = {};
  CNY[1924] = [2,5];
  CNY[1925] = [1,24];
  CNY[1926] = [2,13];
  CNY[1927] = [2,2];
  CNY[1928] = [1,23];
  CNY[1929] = [2,10];
  CNY[1930] = [1,30];
  CNY[1931] = [2,17];
  CNY[1932] = [2,6];
  CNY[1933] = [1,26];
  CNY[1934] = [2,14];
  CNY[1935] = [2,4];
  CNY[1936] = [1,24];
  CNY[1937] = [2,11];
  CNY[1938] = [1,31];
  CNY[1939] = [2,19];
  CNY[1940] = [2,8];
  CNY[1941] = [1,27];
  CNY[1942] = [2,15];
  CNY[1943] = [2,4];
  CNY[1944] = [1,25];
  CNY[1945] = [2,13];
  CNY[1946] = [2,1];
  CNY[1947] = [1,22];
  CNY[1948] = [2,10];
  CNY[1949] = [2,29];
  CNY[1950] = [2,17];
  CNY[1951] = [2,6];
  CNY[1952] = [1,27];
  CNY[1953] = [2,14];
  CNY[1954] = [2,3];
  CNY[1955] = [1,24];
  CNY[1956] = [2,12];
  CNY[1957] = [1,31];
  CNY[1958] = [2,18];
  CNY[1959] = [2,8];
  CNY[1960] = [1,28];
  CNY[1961] = [2,15];
  CNY[1962] = [2,5];
  CNY[1963] = [1,25];
  CNY[1964] = [2,13];
  CNY[1965] = [2,2];
  CNY[1966] = [1,21];
  CNY[1967] = [2,9];
  CNY[1968] = [1,30];
  CNY[1969] = [2,17];
  CNY[1970] = [2,6];
  CNY[1971] = [1,27];
  CNY[1972] = [2,15];
  CNY[1973] = [2,3];
  CNY[1974] = [1,23];
  CNY[1975] = [2,11];
  CNY[1976] = [1,31];
  CNY[1977] = [2,18];
  CNY[1978] = [2,7];
  CNY[1979] = [1,28];
  CNY[1980] = [2,16];
  CNY[1981] = [2,5];
  CNY[1982] = [1,25];
  CNY[1983] = [2,13];
  CNY[1984] = [2,2];
  CNY[1985] = [2,20];
  CNY[1986] = [2,9];
  CNY[1987] = [1,29];
  CNY[1988] = [2,17];
  CNY[1989] = [2,6];
  CNY[1990] = [1,27];
  CNY[1991] = [2,15];
  CNY[1992] = [2,4];
  CNY[1993] = [1,23];
  CNY[1994] = [2,10];
  CNY[1995] = [1,31];
  CNY[1996] = [2,19];
  CNY[1997] = [2,7];
  CNY[1998] = [1,28];
  CNY[1999] = [2,16];
  CNY[2000] = [2,5];
  CNY[2001] = [1,24];
  CNY[2002] = [2,12];
  CNY[2003] = [2,1];
  CNY[2004] = [1,22];
  CNY[2005] = [2,9];
  CNY[2006] = [1,29];
  CNY[2007] = [2,18];
  CNY[2008] = [2,7];
  CNY[2009] = [1,26];
  CNY[2010] = [2,14];
  CNY[2011] = [2,3];
  CNY[2012] = [1,23];
  CNY[2013] = [2,10];
  CNY[2014] = [1,31];
  CNY[2015] = [2,19];
  CNY[2016] = [2,8];
  CNY[2017] = [1,28];
  CNY[2018] = [2,16];
  CNY[2019] = [2,5];
  CNY[2020] = [1,25];
  CNY[2021] = [2,12];
  CNY[2022] = [2,1];
  CNY[2023] = [1,22];
  CNY[2024] = [2,10];
  CNY[2025] = [1,29];
  CNY[2026] = [2,17];
  CNY[2027] = [2,6];
  CNY[2028] = [1,26];
  CNY[2029] = [2,13];
  CNY[2030] = [2,3];
  CNY[2031] = [1,23];
  CNY[2032] = [2,11];
  CNY[2033] = [1,31];
  CNY[2034] = [2,19];
  CNY[2035] = [2,8];
  CNY[2036] = [1,28];
  CNY[2037] = [2,15];
  CNY[2038] = [2,4];
  CNY[2039] = [1,24];
  CNY[2040] = [2,12];
  CNY[2041] = [2,1];
  CNY[2042] = [1,22];
  CNY[2043] = [2,10];
  CNY[2044] = [1,30];
    
  dizhi = ((month < CNY[year][0]) || (month == CNY[year][0] && day < CNY[year][1])) ? dizhi_list[i+1] : dizhi_list[i];
    
  return zodiac + '   &   ' + dizhi;
}